import './index.css'
import BlogCategories from "./categories";
import {useTranslation} from "react-i18next";

const Blogs = () => {


    const {t} = useTranslation()
    return (
        <div className="section section--first">


            <div className="container">

                <div className="row">
                    <div className="col-12">
                        <h1 className="section__title section__title--head">{t('blog.title')}</h1>
                    </div>
                </div>


                <BlogCategories/>


            </div>
        </div>


    )

}

export default Blogs
